<template>
  <b-modal
    id="modal-ttc-concept"
    centered
    title="Add Concept"
    :no-close-on-backdrop="true"
  >
    <!--
    <v-select
      v-model="selected"
      v-validate="{ required: true }"
      :options="options"
      label="name"
      placeholder="Search TTC Concepts"
      data-vv-name="Concept"
      multiple
      @search="debounceSearch"
    ></v-select>
    -->
    <multiselect
              v-model="selected"
              v-validate="{ required: true }"
              label="name"
              track-by="label"
              placeholder="Search Concepts"
              :size="'compact'"
              :options="options"
              :multiple="true"
              :searchable="true"
              :internal-search="false"
              :clear-on-select="false"
              :close-on-select="false"
              :options-limit="300"
              :limit="10"
              @search-change="debounceSearch"
            >
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag multiselect__tag">
                  <span>{{ option.label }}</span>
                  <i class="multiselect__tag-icon" @click="remove(option)"></i>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <span>{{ props.option.label }}</span>
                <i v-if="props.option.searchRequired" class="fa fa-book-open ml-1"></i>
                <i v-if="props.option.searchable" class="fa fa-search ml-1"></i>
              </template>
              <span slot="noResult">
                Oops! No elements found. Consider changing the search query.
              </span>
    </multiselect>

    <template slot="modal-footer">
      <b-btn
        variant="primary"
        class="float-right"
        :disabled="!selected.length"
        @click="addFilters"
        ><i class="fa fa-plus" /> Add to query</b-btn
      >
    </template>
  </b-modal>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import { mapActions } from "vuex";

export default {
  name: "ConceptSearchModal",
  components: {
    vSelect,
    Multiselect
  },
  data() {
    return {
      search: null,
      selected: [],
      options: []
    };
  },
  computed: {
    selectedFormatted() {
      return this.selected.map(
        concept =>
          (concept = {
            id: concept.id,
            title: concept.name,
            topic_id: concept.topic_id,
            theme_id: concept.theme_id
          })
      );
    }
  },
  methods: {
    ...mapActions(["searchTTCConcepts"]),
    addFilters() {
      this.$emit("addToQuery", "ttc-concept", this.selectedFormatted);
      this.$bvModal.hide("modal-ttc-concept");
      this.selected = [];
    },
    debounceSearch: _.debounce(function(val) {
      this.searchTTCConcepts({ query: val }).then(res => {
        this.options = res.map(
          concept =>
            (concept = {
                ...concept,
                label: concept.name,
                value: concept.id
            })
        );
      });
    }, 400)
  }
};
</script>
